<template>
    <div v-if="!friendsAndFamily">
        <section class="row" id="edit-column-width">

            <b-col sm="12">
                <div class="form-horizontal">

                    <h6 v-if="$store.state.wishlistType === 'wishlist'" style="margin-bottom:4%;" class="section-heading">Your Honeymoon Wishlist Contributions</h6>
                    <h6 v-if="$store.state.wishlistType === 'giftlist'" style="margin-bottom:4%;" class="section-heading">Your Wishlist Contributions</h6>
                    <!-- Guest Card Main Section -->
                    <div class="form-group form-group-venue text-center" >
                          
                        <b-col sm="12" >
                            <div class="form-group form-group-venue">
                                <b-row>
                                <label for="" class="col-sm-2 control-label"></label>
                                <b-col sm="12">
                                    <h4 v-if="$store.state.user.couple_title">{{$store.state.user.couple_title}}</h4>
                                    <h4 v-else-if="$store.state.user.person_01.first_name && $store.state.user.person_02.first_name">{{$store.state.user.person_01.first_name}} & {{$store.state.user.person_02.first_name}}</h4>
                                    <h4 v-else>{{$store.state.user.person_01.first_name}}</h4>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <ul class="list-unstyled">
                                        <li>Event Date: <strong><span>{{ $store.state.user.wedding_day.date }}</span></strong></li>
                                        <li>Last Date Of Contributions: <strong><span>{{ $store.state.user.contributions_closing.pretty }}</span></strong></li>
                                        <li>Total Contributions To Date: <strong><span>{{ currency }}{{ $store.state.user.contributions_total }}</span></strong></li>
                                    </ul>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="6">
                                    <a v-if="$store.state.wishlistType === 'giftlist'" style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:75%;" class="btn btn-primary mt-2"  @click="toggleContr = !toggleContr" >View Contributions</a>
                                    <a v-else style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:75%;" class="btn btn-primary mt-2"  @click="toggleContr = !toggleContr" >View Contributions</a>
                                </b-col>
                                <b-col sm="6">
                                    <a v-if="$store.state.wishlistType === 'giftlist'" style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:75%;" class="btn btn-primary mt-2" @click="downloadSection('tmpl_2')">Save/Print Messages</a>
                                    <a v-else style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:75%;" class="btn btn-primary mt-2" @click="downloadSection('tmpl_2')">Save/Print Messages</a>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <p>You have chosen to receive contributions by: 
                                        <strong v-if="$store.state.user.payment_options === 'BOOKING'">Add to my booking</strong>
                                        <strong v-else>Email me a Gift Card</strong>
                                    </p>
                                </b-col>
                                </b-row>
                            </div>

                            <div v-if="!paymentOptionUpdated" class="form-group form-group-venue">
                                <b-row class="mx-auto">
                                <b-col sm="12">
                                 
                                   
                                        <b-form-checkbox
                                            v-model="paymentOptions"
                                            name="paymentOptions"
                                            :value="oppisiteOptionValue"
                                            :unchecked-value="null">
                                            &nbsp; Would you like to modify your payment option to <br/> "{{oppisiteOption}}"
                                        </b-form-checkbox>
                                   
                                </b-col>
                                </b-row>
                            </div>

                            <div v-if="$store.state.user.payment_options === 'BOOKING' || paymentOptions === 'BOOKING'" class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="8">
                                        <label for="BookRef" class="float-start">Booking Reference: </label>
                                    </b-col>
                                </b-col>
                                </b-row>
                            </div>

                            <div v-if="$store.state.user.payment_options === 'BOOKING' || paymentOptions === 'BOOKING'" class="form-group form-group-venue">
                                <b-row>
                                    <b-col sm="1"></b-col>
                                    <b-col sm="10">
                                        <b-form-input v-model.trim="honeymoon_booking_number" placeholder="Booking Reference"></b-form-input>
                                        <div class="alert alert-danger mb-0" v-if="bookNoWarning">Field is required</div>
                                    </b-col>
                                </b-row>
                            </div>

                            <div v-if="paymentOptions !== null|| $store.state.user.honeymoon_booking_number !== honeymoon_booking_number" class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <button v-if="$store.state.wishlistType === 'giftlist'" style="background-color: orange; color: white; border: none; border-radius: 0% !important; width:35%;" class="btn btn-primary mt-2 float-center" @click="updatePaymentOption()">Update</button>
                                    <button v-else style="background-color: pink; color: white; border: none; border-radius: 0% !important; width:35%;" class="btn btn-primary mt-2 float-center" @click="updatePaymentOption()">Update</button>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <div>
                                        <b-alert variant="success" style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;" v-show="showSuccessPaymentOpt" show>
                                            Your Payment Option has been updated successfully.
                                        </b-alert>

                                        <b-alert variant="danger" style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;" v-show="showErrorPaymentOpt" show>
                                            There has been an error proccessing your request . please call us on <a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link' : null">{{ telNo }}</a>
                                        </b-alert>
                                    </div>
                                </b-col>
                                </b-row>
                            </div>


                            <hr>

                            <div v-if="toggleContr">
                                <div class="form-group form-group-venue">
                                    <b-row>
                                    <label for="" class="col-sm-2 control-label"></label>
                                    <b-col sm="12">
                                        <h5>All Contributions</h5>
                                    </b-col>
                                    </b-row>
                                </div>

                                <div class="form-group form-group-venue">
                                    <b-row>
                                    <label for="" class="col-2 control-label"></label>
                                    <b-col sm="12">
                                        <b-row v-for="contributor in liveContributions" :key="contributor.uid">
                                            <b-col sm=5>
                                                <b-form-checkbox
                                                    v-if="!contributor.emailed"
                                                    v-model="messageList"
                                                    name="responseList"
                                                    :value="contributor._id"
                                                    size="sm">
                                                    &nbsp;{{contributor.name_payee}}
                                                </b-form-checkbox>
                                                <p v-else>&nbsp;{{contributor.name_payee}}<br>
                                                (Thank you note sent)</p>
                                            </b-col>
                                            <b-col sm=2>
                                                    <p v-if="contributor.currency === 'GBP'">£{{contributor.amount}}</p>
                                                    <p v-else>€{{contributor.amount}}</p>
                                            </b-col>
                                            <b-col sm=5>
                                                <p>{{contributor.message}}</p>
                                            </b-col>
                                            
                                            <b-col sm=12>
                                                <hr>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    </b-row>
                                </div>

                                <hr>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <h4>Thank Your Loved Ones</h4>
                                </b-col>
                                </b-row>
                            </div>
                            
                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="10">
                                        <label for="Contributors" class="float-left">Select Contributor(s) </label>
                                    </b-col>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="1"></b-col>
                                <b-col sm="10">
                                    <button @click="showContributors = !showContributors" class="dropdown-toggle-wishlist">Say "Thank you" to... <span class="caret"></span></button>
                                </b-col>
                                </b-row>
                            </div>

                            <div v-if="showContributors" class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                        <b-col sm="12">
                                            <b-form-checkbox
                                                v-model="selectAll"
                                                value="selectAll"
                                                unchecked-value="unselectAll"
                                                >
                                                Select All
                                            </b-form-checkbox>
                                        </b-col>
                                        <!-- <b-row > -->
                                        <b-col sm="12">
                                            <b-row>
                                                <b-col v-for="contributor in liveContributions" :key="contributor.uid" sm="6" class="mt-3">
                                                    <b-form-checkbox
                                                        v-if="!contributor.emailed"
                                                        v-model="messageList"
                                                        name="messageList"
                                                        :value="contributor._id">
                                                        {{contributor.name}}
                                                    </b-form-checkbox>
                                                
                                                    <b-form-checkbox
                                                        v-if="contributor.emailed"
                                                        v-model="messageList"
                                                        name="messageList"
                                                        :value="contributor._id "
                                                        disabled>
                                                        {{contributor.name}}
                                                    </b-form-checkbox>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                        </b-col>

                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="8">
                                        <label for="Email Heading" class="float-left">Email Heading: </label>
                                    </b-col>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <h4><i class="material-icons" style="transform:rotate(180deg);">format_quote</i> Thank you for your contribution.<i class="material-icons">format_quote</i></h4>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <b-col sm="1"></b-col>
                                    <b-col sm="8">
                                        <label for="Message" class="float-left">Your Message: </label>
                                    </b-col>
                                </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                    <b-col sm="1"></b-col>
                                    <b-col sm="10">
                                        <b-form-textarea
                                            class="text-center"
                                            :formatter="formatMessage"
                                            id="textarea"
                                            v-model="thankyouMessage"
                                            placeholder="Enter Thankyou Message..."
                                            rows="3"
                                            max-rows="6">
                                        </b-form-textarea>
                                    </b-col>
                                </b-row>
                            </div>

                            <div class="form-group form-group-venue">
                                <b-row>
                                <b-col sm="12">
                                    <button v-if="$store.state.wishlistType === 'giftlist'" style="background-color: orange; color: white; border: none; border-radius: 0% !important;" class="btn btn-primary mt-2 float-center" @click="sendEmails()">Send</button>
                                    <button v-else style="background-color: pink; color: white; border: none; border-radius: 0% !important;" class="btn btn-primary mt-2 float-center" @click="sendEmails()" >Send</button>
                                    <div class="error-box">
                                        <p class="bg-success text-center" style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;" v-show="showSuccess">
                                            Your email(s) have been sent successfully.
                                        </p>

                                        <p class="bg-warning text-center" style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;" v-show="showNotValid">
                                            Please Select Contributors that you want to email.
                                        </p>

                                        <p class="bg-danger text-center" style="padding: 15px; width: 80%; margin-left:10%; margin-top: 2%;" v-show="showError">
                                            There has been an error proccessing your email . please call us on <a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link' : null">{{ telNo }}</a>
                                        </p>
                                    </div>
                                </b-col>
                                </b-row>
                            </div>

                        </b-col>

                    </div>

                </div>
            </b-col>
            <div style="display:none;" class="section printable showPrint" id="tmpl_2">
                <div id="contrib-print">
                    <div>
                        <img style="width: 70%; margin-left:15%" src="https://www.trailfinders.com/graphics/weddings/banner-wishlist-print.jpg" class="banner" alt="wishlist Banner">
                        <h2 style="text-align: center; padding-top: 3%; padding-bottom: 0%; font-family: 'PT Sans', sans-serif;
                        ">{{ $store.state.user.person_01.first_name }} & {{ $store.state.user.person_02.first_name }}</h2>
                        <h3 style="text-align: center; padding-top: 1%; padding-bottom: 1%; font-family: 'PT Sans', sans-serif;
                        "><span class="title-case">Wedding</span> on {{ day}} {{ month}} {{ year}}</h3>
                        <img src="https://www.trailfinders.com/graphics/weddings/heart.png" alt="hearts divider" class="divider" style="margin-left:15%; width: 70%;">
                    </div>

                    <article class="col-sm-6" style="page-break-inside: avoid" v-for="(contributor,index) in liveContributions" :key=index >
                        <div style="display: flex; justify-content: center; flex-direction: row; padding-top: 2.5%; padding-bottom: 2.5%;">
                            <div style="flex-direction: column; justify-content: center;">
                                <h4 style="text-align: center; padding-top: 1%; padding-bottom: 1%; font-family: 'PT Sans', sans-serif;
                            ">{{contributor.name}}</h4>
                                <p style="text-align: center; padding-top: 1%; padding-bottom: 1%; font-family: 'PT Sans', sans-serif;
                            ">{{contributor.message}}</p>
                                <h5 style="text-align: center; padding-top: 1%; padding-bottom: 1%; font-family: 'PT Sans', sans-serif;
                            ">{{contributor.currency}}{{contributor.amount}}</h5>
                            </div>
                        </div>
                        <img src="https://www.trailfinders.com/graphics/weddings/heart.png" alt="hearts divider" class="divider" style="margin-left:15%; width: 70%;">
                    </article>
                    <footer><img  width="30%" src="https://mailimages.trailfinders.com/graphics/email/honeymoons/tf-honeymoon-wish-list-logo.png" alt="Trailfinders Honeymoon Wishlist"></footer>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import { getContributions, sendThankyouEmail, updateWishlist } from "../../services/api";
import moment from "moment";
  
export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      modifyPayment: null,
      currency:'£',
      showContributors: false,
      thankyouMessage: '',
      isIe: false,
      ref:'.com',
      liveContributions:[],
      paymentOptionUpdated: false,
      showError: false,
      showSuccessPaymentOpt: false,
      showErrorPaymentOpt: false,
      showSuccess: false,
      showNotValid: false,
      toggleContr: false,
      responseList: [],
      messageList: [],
      selectAll:[],
      friendsAndFamily: null,
      honeymoon_booking_number:'',
      formatIds: [],
      year:'',
      bookNo: null,
      bookNoWarning: false,
      previousOption: null,
      oppisiteOption: null,
      oppisiteOptionValue: null,
      month:'',
      paymentOptions: null,
      day:'',
      telNo: null
   };
  },
  methods: {

    downloadSection(_elID) {
            this.personalMessageRequired = false
            if (this.gcMessage === '' && this.personaliseMessage === 'true') {
                this.personalMessageRequired = true
            } else {
            this.gc_preview = false
            var prtContent = document.getElementById(_elID);
            var WinDownload = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            WinDownload.document.write('<link rel="stylesheet" href="https://www.trailfinders.com//codesource/weddings/css/site.css">');
            WinDownload.document.write(prtContent.innerHTML);
            WinDownload.document.documentElement.className += 'windownload';
            setTimeout(
                function(){
                    WinDownload.print()
                }, 500
            );
            }
    },
    async getContributions() {
        let res = await getContributions(this.$store.state.wishlistType, this.$store.state.user._id )
        if (res.error) {
            this.showError = true
         } else {
            // this.showSuccess = true
            // this.$store.dispatch('setUserAction',res.data)
            let live = res.data.filter((contribution) => contribution.status === "live")
            this.liveContributions = live
        }
    },
    formatMessage(value) {
        this.$store.state.user.welcome_message = `<p>`+ value + `</p>`
        return value
    },
    async updatePaymentOption() {
        this.showErrorPaymentOpt = false
        this.showSuccessPaymentOpt = false
        this.bookNoWarning = false
        if (this.bookNo === '' || this.bookNo.length === 0 && this.paymentOptions === 'BOOKING') {
            this.bookNoWarning = true
        } else {
            if (this.paymentOptions === 'BOOKING') {
                this.$store.state.user.honeymoon_booking_number = this.honeymoon_booking_number
                this.$store.state.user.payment_options_post = 'BOOKING'
                this.$store.state.user.payment_options = 'BOOKING'
            } else {
                this.$store.state.user.payment_options = this.paymentOptions
                this.$store.state.user.payment_options_post = "GIFTCARD"
                this.$store.state.user.payment_options = 'GIFTCARD'
            }
            this.$store.dispatch('setUserAction',this.$store.state.user)
            let dataObj = this.$store.state.user
            dataObj.internal = true
            let res = await updateWishlist(this.$store.state.wishlistType,this.$store.state.user._id, dataObj)
            if (res.error) {
                this.showErrorPaymentOpt = true
            } else {
                this.paymentOptions = null
                this.paymentOptionUpdated = true
                this.showSuccessPaymentOpt = true
            }
        } 
    },
    async sendEmails() {
        this.showError = false
        this.showSuccess = false
        this.showNotValid = false
        if (this.messageList.length > 0) {
            
        let data = {
            contributors: this.messageList,
            message: this.thankyouMessage
        }
        let res = await sendThankyouEmail(this.$store.state.wishlistType ,this.$store.state.user._id, data) 
        if (res.error) {
            this.showError = true
         } else {
            this.messageList = []
            this.getContributions()
            this.showSuccess = true
            // this.liveContributions = live
        }
    } else {
        this.showNotValid = true
    }

    },
    
  },
  watch: {
      selectAll() {
      if (this.selectAll.includes('selectAll')) {
                this.liveContributions.filter((contr) => {
                  if (contr.emailed === false) {
                      return this.messageList.push(contr._id)
                  }
                  return this.messageList
              })
        } else if (this.selectAll.length === 0) {
            return this.messageList = []
        } else {
              return this.messageList
        }
      }
  },
  mounted() {
    if (this.$route.params.wishlistType === "friends-and-family"){
          this.friendsAndFamily = true 
    }
    if (this.$store.state.user.honeymoon_booking_number) {
        this.honeymoon_booking_number = this.$store.state.user.honeymoon_booking_number
    } 
    if (this.$store.state.user.payment_options === 'BOOKING') {
        // this.paymentOptions = "BOOKING"
        this.oppisiteOptionValue = "GIFTCARD"
        this.oppisiteOption = "Email Me A Giftcard"
        this.previousOption = 'BOOKING'
    } else {
        // this.paymentOptions = "GIFTCARD"
        this.oppisiteOptionValue = "BOOKING"
        this.oppisiteOption = "Add To My Booking"
        this.previousOption = 'GIFTCARD'
    }
    this.bookNo = this.$store.state.user.reference
    const d = new Date(this.$store.state.user.wedding_day.iso);
    this.day = moment(d).format('DD')
    this.month = moment(d).format('MMMM')
    this.year = moment(d).format('YYYY')
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true
      this.ref = '.ie'
      this.priceCharge = '€15'
      this.currency = '€'
    } else {
      this.isIe = false
      this.ref = '.com'
      this.priceCharge = '£15'
      this.currency = '£'
    }
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
        this.telNo = '01 881 4990'
    } else if (this.$store.state.wishlistType === 'giftlist') { 
        this.telNo = '020 7408 9008'
    } else {
        this.telNo = '020 7084 6512'
    } 
    this.getContributions()
    this.meta.loaded = true;
  },
};

</script>

<style>
.dropdown-toggle-wishlist {
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: #dadada;
    background-color: white;
    /* width: 100%; */
    padding: 16px 15px;
    margin-bottom: 20px;
    font-size: 100% !important;
    color: #999999;
    text-align: left;
    width: 95%;
}
</style>
<style lang="scss">
@media print {
    .pagebreak { page-break-before: always; } /* page-break-after works, as well */
    @page { size: portrait; }
}

.dropdown-toggle-wishlist .caret {
    position: absolute;
    right: 30px;
    top: 70%;
    margin-top: -12px;
    border-top: 6px dashed;
    border-top: 6px solid \9;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    padding-top: 30%;
    margin-right:1%;
}
.dropdown-toggle-wishlist {
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: #dadada;
    background-color: white;
    width: 100%;
    padding: 16px 15px;
    margin-bottom: 20px;
    font-size: 13.0px;
    color: #999999;
    text-align: left;
}
.dropdown-menu {
    margin: -20px 0 0 0;
    padding: 20px;
   
}
// .post-code-results {
//     position: absolute;
//     width: 100%;
//     background-color: #fff;
//     height: 150px;
//     overflow-y: scroll;
//     -webkit-box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.75);
//     -moz-box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.75);
//     box-shadow: 2px 3px 5px 0px rgba(0,0,0,0.75);
//     ul {
//       list-style: none;
//     }
//     li {
//       margin: 5px 0;
//     }
//     li:hover {
//       background-color: #ffa409;
//       cursor: pointer;
//     }
//   }


</style>
<style>